import React, { useEffect, useState } from 'react'
import {
  Col,
  Form,
  Input,
  Modal,
  notification,
  Radio,
  Row,
  Space,
  Upload,
} from 'antd'
import { useDispatch, useSelector } from 'react-redux'
import styles from './versionManagement.module.css'
import { RootDispatch } from '../../app/store'
import {
  MinusCircleOutlined,
  PlusCircleOutlined,
  PlusOutlined,
  SearchOutlined,
} from '@ant-design/icons'
import { nanoid, unwrapResult } from '@reduxjs/toolkit'
import {
  getAddVersiobSubmitAsync,
  getAddVersionCheckNameAsync,
  getVersionDetailAsync,
  getVersionListAsync,
} from './versionManagementSlice'
import { OssParams } from '../../models/ossparams'
import {
  getFileUploadToken,
  uploadFileCloud,
} from '../../compnents/file/fileSlice'
import { getUrl } from '../treatment/diagnosis/diagnosisSlice'

export const AddVersionModal = (props: {
  id?: any
  labelList?: number
  name?: string
  visible: boolean
  onOk: () => void
  onCancel: () => void
}) => {
  const dispatch = useDispatch<RootDispatch>()

  const [form] = Form.useForm()

  const [imageUrl, setImageUrl] = useState<any>()

  const [lableList, setLableList] = useState<any[]>([])

  const [detail, setDetail] = useState<any>()

  const [accountNum, setAccountNum] = useState<any>()
  const [accountFlag, setAccountFlag] = useState(false)

  const [isLinkState, setIsLinkState] = useState<any>()
  const [isLinkFlag, setIsLinkFlag] = useState(false)

  const [isEditState, setIsEditState] = useState<any>()
  const [isEditFlag, setIsEditFlag] = useState(false)

  const [moneyNum, setMoneyNum] = useState<any>()
  const [moneyFlag, setMoneyFlag] = useState(false)

  const [isEditDefaultMenuState, setIsEditDefaultMenuState] = useState<any>()
  const [isEditDefaultMenuFlag, setIsEditDefaultMenuFlag] = useState(false)


  const [isZeroRecipeState, setIsZeroRecipeStateState] = useState<any>()
  const [isZeroRecipeStateFlag, setIsZeroRecipeStateFlag] = useState(false)


  const rowProps = {
    gutter: 4,
  }

  const uploadButton = (
    <div>
      <PlusOutlined />
    </div>
  )

  console.log(imageUrl, 'imageUrl')

  const columnLayout = {
    labelCol: { flex: '12rem' },
    wrapperCol: { flex: 1 },
  }

  useEffect(() => {
    if (props?.visible && !props?.id) {
      dispatch(getVersionListAsync())
        .then(unwrapResult)
        .then((v) => {
          setDetail({ versionPropertiesVOList: v })
        })
    }
  }, [props?.visible])

  useEffect(() => {
    if (props?.visible) {
      setImageUrl('')
      if (props?.id) {
        dispatch(getVersionDetailAsync(props?.id))
          .then(unwrapResult)
          .then((v: any) => {
            setDetail(v)

            setLableList(v?.labels ? v?.labels?.split(',') : [])
            form.setFieldsValue({
              name: v?.name,
              versionEdition: v?.versionEdition,
            })
          })
      }

      setAccountFlag(false)
      setIsLinkFlag(false)
      setIsEditFlag(false)
      setIsEditDefaultMenuFlag(false)
      setMoneyFlag(false)
    }
  }, [props?.visible, props?.id])

  useEffect(() => {
    if (props?.visible)
      if (props?.id) {
        if (lableList?.length) {
          form.setFieldsValue({
            labelList: [...lableList],
          })
        } else {
          form.setFieldsValue({
            labelList: [''],
          })
        }
      }
  }, [lableList, props?.id, props?.visible])

  useEffect(() => {
    if (props?.visible) {
      form.setFieldsValue({
        labelList: [''],
      })
    }
  }, [props?.visible])

  useEffect(() => {
    if (props?.id) {
      if (detail) {
        const list = detail?.versionPropertiesVOList
        const valueOne = list?.filter((v: any) => v?.propName == '1')?.[0]
        const valueTwo = list?.filter((v: any) => v?.propName == '2')?.[0]
        const valueThree = list?.filter((v: any) => v?.propName == '3')?.[0]
        const valueFour = list?.filter((v: any) => v?.propName == '4')?.[0]
        const valueSix = list?.filter((v: any) => v?.propName == '6')?.[0]
        const valueSeven = list?.filter((v: any) => v?.propName == '7')?.[0]

        form.setFieldsValue({
          accountNum: accountFlag ? accountNum : valueOne?.propValue,
          isLink: isLinkFlag
            ? isLinkState
            : valueTwo?.propValue == 'true'
            ? 1
            : 0,
          isEdit: isEditFlag
            ? isEditState
            : valueThree?.propValue == 'true'
            ? 1
            : 0,
          isDefaultMenu: isEditDefaultMenuFlag
            ? isEditDefaultMenuState
            : valueSix?.propValue == 'true'
            ? 1
            : 0,
          isZeroRecipe: isZeroRecipeStateFlag
              ? isZeroRecipeState
              : valueSeven?.propValue == 'true'
                  ? 1
                  : 0,
          money: moneyFlag ? moneyNum : valueFour?.propValue,
        })
      }
    }
  }, [
    detail,
    accountFlag,
    accountNum,
    isLinkFlag,
    isLinkState,
    isEditFlag,
    isEditState,
    isEditDefaultMenuFlag,
    isEditDefaultMenuState,
    moneyFlag,
    moneyNum,
    props?.id,
      isZeroRecipeStateFlag,
      isZeroRecipeState
  ])

  useEffect(() => {
    if (!props?.id) {
      if (detail) {
        form.setFieldsValue({
          accountNum: accountFlag ? accountNum : '',
          isLink: isLinkFlag ? isLinkState : false,
          isEdit: isEditFlag ? isEditState : 'false',
          money: moneyFlag ? moneyNum : '',
          isDefaultMenu: isEditDefaultMenuFlag
            ? isEditDefaultMenuState
            : false,
          isZeroRecipe: isZeroRecipeStateFlag
        })
      }
    }
  }, [
    detail,
    accountFlag,
    accountNum,
    isLinkFlag,
    isLinkState,
    isEditFlag,
    isEditState,
    isEditDefaultMenuFlag,
    isEditDefaultMenuState,
    moneyFlag,
    moneyNum,
    props?.id,
  ])
  return (
    <div>
      <Modal
        className={styles.model}
        title={props?.id ? '编辑版本' : '新增版本'}
        visible={props.visible}
        okText='确认'
        cancelText='取消'
        onOk={(v) => {
          form.validateFields().then((values: any) => {
            console.log(values, 'vvvvvvvv')
            dispatch(
              getAddVersionCheckNameAsync({
                name: values?.name,
                versionId: props?.id ? detail?.id : undefined,
              })
            ).then((v: any) => {
              console.log(v, 'dddddddd')
              if (v?.payload) {
                dispatch(
                  getAddVersiobSubmitAsync({
                    version: {
                      id: props.id,
                      name: values?.name,
                      labels: values?.labelList?.join(','),
                      versionEdition: values?.versionEdition == true ? 1 : 0,
                    },
                    versionPropertiesList: detail?.versionPropertiesVOList?.map(
                      (v: any) => {
                        return {
                          ...v,
                          propValue:
                            v?.propName == '1'
                              ? values?.accountNum
                              : v?.propName == '2'
                              ? values?.isLink == 1
                                ? true
                                : false
                              : v?.propName == '3'
                              ? values?.isEdit == 1
                                ? true
                                : false
                              : v?.propName == '4'
                              ? values?.money
                              : v?.propName == '5'
                              ? imageUrl
                              : v?.propName == '6'
                              ? values?.isDefaultMenu == 1
                                ? true
                                : false
                                                    : v?.propName == '7'
                                                        ? values?.isZeroRecipe == 1
                                                            ? true
                                                            : false
                              : '',
                        }
                      }
                    ),
                  })
                )
                  .then(unwrapResult)
                  .then(() => {
                    notification.success({ message: '保存成功', duration: 3 })
                    form.resetFields()
                    props.onOk()
                  })
              } else {
                notification.info({
                  message: '版本名称已存在',
                })
              }
            })
          })
        }}
        onCancel={() => {
          form.resetFields()
          props.onCancel()
          form.setFieldsValue({
            labelList: [''],
          })
          setDetail({})
        }}
        width='850px'
      >
        <Form
          name='dynamic_form_item'
          form={form}
          autoComplete='off'
          onFinish={(vs) => {
            form.resetFields()
            props.onOk()
          }}
        >
          <Row {...rowProps}>
            <Col span={24}>
              <Form.Item
                {...columnLayout}
                label='版本名称'
                name='name'
                rules={[{ required: true, message: '请输入版本名称' }]}
              >
                <Input style={{ width: '600px' }} />
              </Form.Item>
            </Col>
          </Row>
          <Row {...rowProps}>
            <Col span={24}>
              <Form.Item
                {...columnLayout}
                label='版本类型'
                name='versionEdition'
                rules={[{ required: true, message: '请输入版本类型' }]}
              >
                <Radio.Group style={{ marginTop: '2px' }}>
                  <Radio value={1}> 口腔版 </Radio>
                  <Radio value={0}> 通用版 </Radio>
                </Radio.Group>
              </Form.Item>
            </Col>
          </Row>
          <Row {...rowProps}>
            <Col span={24}>
              <Form.List name='labelList' {...columnLayout}>
                {(fields: any, { add, remove }) => (
                  <>
                    {fields.map((field: any, index: any) => (
                      <Form.Item
                        {...columnLayout}
                        className={styles.name}
                        label={'标签' + (index + 1)}
                        required={true}
                        rules={[{ required: true, message: '请输入标签' }]}
                        key={field.key}
                      >
                        <Form.Item
                          {...field}
                          rules={[{ required: true, message: '请输入标签' }]}
                          validateTrigger={['onChange', 'onBlur']}
                          noStyle
                        >
                          <Input
                            placeholder='请输入'
                            style={{ width: ' 200px' }}
                          />
                        </Form.Item>
                        {fields.length > 1 ? (
                          <a
                            className={styles.add}
                            onClick={() => remove(field.name)}
                          >
                            <MinusCircleOutlined
                              style={{
                                marginLeft: '10px',
                                fontSize: '24px',
                                color: '#999999',
                              }}
                            />
                          </a>
                        ) : null}
                        {fields.length === index + 1 ? (
                          <a onClick={() => add()}>
                            <PlusCircleOutlined
                              style={{
                                marginLeft: '10px',
                                fontSize: '24px',
                                color: '#999999',
                              }}
                            />
                          </a>
                        ) : null}
                      </Form.Item>
                    ))}
                  </>
                )}
              </Form.List>
            </Col>
          </Row>

          {detail?.versionPropertiesVOList?.map((v: any) => {
            return (
              <>
                <Row {...rowProps}>
                  <Col span={24}>
                    <Form.Item
                      {...columnLayout}
                      label={v?.name}
                      name={
                        v?.propName == '1'
                          ? 'accountNum'
                          : v?.propName == '2'
                          ? 'isLink'
                          : v?.propName == '3'
                          ? 'isEdit'
                          : v?.propName == '4'
                          ? 'money'
                          : v?.propName == '6'
                          ? 'isDefaultMenu'
                          : v?.propName == '7'
                          ? 'isZeroRecipe'
                          : ''
                      }
                      rules={[
                        {
                          required: v?.propName == '5' ? false : true,
                          message:
                            v?.propName == '1' || v?.propName == '4'
                              ? `请输入${v?.name}`
                              : '请选择',
                        },
                      ]}
                    >
                      {v?.propName == '1' ? (
                        <>
                          <Input
                            style={{ width: '200px' }}
                            onChange={(v) => {
                              setAccountFlag(true)
                              setAccountNum(v?.target?.value)
                            }}
                            value={accountFlag ? accountNum : v?.propValue}
                          />
                          <span style={{ marginLeft: '14px' }}>个</span>
                        </>
                      ) : v?.propName == '2' ? (
                        <>
                          <Radio.Group
                            style={{ marginTop: '2px' }}
                            onChange={(v) => {
                              setIsLinkFlag(true)
                              console.log(v?.target?.value, 'v?.target?.value')
                              setIsLinkState(v?.target?.value)
                            }}
                            value={
                              isLinkFlag
                                ? isLinkState
                                : v?.propValue == 'true'
                                ? 1
                                : 0
                            }
                          >
                            <Radio value={1}> 是 </Radio>
                            <Radio value={0}> 否 </Radio>
                          </Radio.Group>
                        </>
                      ) : v?.propName == '3' ? (
                        <>
                          <Radio.Group
                            style={{ marginTop: '2px' }}
                            onChange={(v) => {
                              setIsEditFlag(true)
                              console.log(v?.target?.value, 'v?.target?.value')
                              setIsEditState(v?.target?.value)
                            }}
                            value={
                              isEditFlag
                                ? isEditState
                                : v?.propValue == 'true'
                                ? 1
                                : 0
                            }
                          >
                            <Radio value={1}> 是 </Radio>
                            <Radio value={0}> 否 </Radio>
                          </Radio.Group>
                        </>
                      ) : v?.propName == '4' ? (
                        <>
                          <Input
                            style={{ width: '200px' }}
                            onChange={(v) => {
                              setMoneyFlag(true)
                              setMoneyNum(v?.target?.value)
                            }}
                            value={moneyFlag ? moneyNum : v?.propValue}
                          />
                        </>
                      ) : v?.propName == '5' ? (
                        <>
                          <Upload
                            beforeUpload={(file) => {
                              if (file.size / 1024 < 100) {
                                return true
                              } else {
                                notification.info({
                                  message: '图片大于100kb,请重新选择!',
                                })
                                return false
                              }
                            }}
                            accept={'.png,.jpg,.jpeg,bmp'}
                            name='avatar'
                            listType='picture-card'
                            className='avatar-uploader'
                            showUploadList={false}
                            customRequest={async ({
                              file,
                              onSuccess,
                              onError,
                            }) => {
                              let params: OssParams | undefined
                              if (file instanceof File) {
                                try {
                                  params = unwrapResult(
                                    await dispatch(
                                      getFileUploadToken('hydhis-public')
                                    )
                                  )
                                  const index = file.name.lastIndexOf('.')
                                  const ext =
                                    index >= 0 ? file.name.substring(index) : ''
                                  const key = unwrapResult(
                                    await dispatch(
                                      uploadFileCloud({
                                        ...params,
                                        file,
                                        key: `${nanoid()}${ext}`,
                                      })
                                    )
                                  )
                                  onSuccess?.(
                                    null,
                                    (null as unknown) as XMLHttpRequest
                                  )
                                  await dispatch(
                                    getUrl({
                                      fileName: key,
                                      bucketName: 'hydhis-public',
                                    })
                                  ) //获取图片路径
                                    .then(unwrapResult)
                                    .then((res: any) => {
                                      setImageUrl(res as string)
                                    })
                                } catch (e) {
                                  notification.error({
                                    message: '上传失败',
                                  })
                                  // setUploadLoading(false)
                                }

                                // setImageUrl((await getBase64(file)) as string)
                              }
                            }}
                          >
                            {imageUrl || v?.propValue ? (
                              <img
                                src={imageUrl || v?.propValue}
                                alt='avatar'
                                style={{ width: '100%' }}
                              />
                            ) : (
                              uploadButton
                            )}
                          </Upload>
                        </>
                      ) : v?.propName == '6' ? (
                        <>
                          <Radio.Group
                            style={{ marginTop: '2px' }}
                            onChange={(v) => {
                              setIsEditDefaultMenuFlag(true)
                              console.log(v?.target?.value, 'v?.target?.value')
                              setIsEditDefaultMenuState(v?.target?.value)
                            }}
                            value={
                              isEditDefaultMenuFlag
                                ? isEditDefaultMenuState
                                : v?.propValue == 'true'
                                ? 1
                                : 0
                            }
                          >
                            <Radio value={1}> 是 </Radio>
                            <Radio value={0}> 否 </Radio>
                          </Radio.Group>
                        </>
                      ) : v?.propName == '7' ? (
                          <>
                            <Radio.Group
                                style={{ marginTop: '2px' }}
                                onChange={(v) => {
                                  setIsZeroRecipeStateFlag(true)
                                  console.log(v?.target?.value, 'v?.target?.value')
                                  setIsZeroRecipeStateState(v?.target?.value)
                                }}
                                value={
                                  isZeroRecipeStateFlag
                                      ? isZeroRecipeState
                                      : v?.propValue == 'true'
                                          ? 1
                                          : 0
                                }
                            >
                              <Radio value={1}> 是 </Radio>
                              <Radio value={0}> 否 </Radio>
                            </Radio.Group>
                          </>
                      ) : (
                        <></>
                      )}
                    </Form.Item>
                  </Col>
                </Row>
              </>
            )
          })}
        </Form>
      </Modal>
    </div>
  )
}
